import React from 'react';

import * as Misc from "../../misc";

export default ({type, click}) => {
  let caption = '';
  let classPostfix = '';
  switch (type) {
    case 'accept':
      caption = 'Accept';
      classPostfix = 'accept';
      break;
    case 'reset':
      caption = 'Reset';
      classPostfix = 'reset';
      break;
    default:
      throw 'Unsupported button type: ' + type;
  }

  return (
    <div className={"filter-button-wrapper-" + classPostfix} onClick={e => Misc.ignore(e, () => click(type))}>
      <div className={"filter-" + classPostfix + "-button-listitem-renderers-mini"}>{caption}</div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/stones/filterContentHolderButton.js